export default __webpack_public_path__ + "static/media/apple-button.bdeb6b17.svg";